import { Dictionary } from '../../types/i18n';

export const et: Dictionary = {
  meta: { locale: 'et-EE' },
  nav: {
    stable: 'Tall',
    horses: 'Hobused',
    rides: 'Matkad ja hinnad',
    booking: 'Broneerimine',
    events: 'Üritused',
    rules: 'Hea teada',
    book: 'Broneeri',
    menu: 'Menüü',
  },
  hero: {
    location: '25 km Tallinnast · 30 minutit lennujaamast',
    title: 'Araabia hobused, männimets ja meri',
    subtitle:
      'Juhendajaga ratsamatkad igale tasemele — esimesest rahulikust sammust galopini Läänemere rannal. Väikesed grupid, sõbralikud hobused, ajad valge aja järgi.',
    cta: 'Broneeri matk',
    secondary: 'Tutvu hobustega',
  },
  notice: {
    rides: 'Matkade online-broneerimine alates 1. novembrist 2026.',
    events: 'Pulmad ja fotosessioonid 2027. hooajaks (alates aprillist) — broneeri oma kuupäev juba praegu.',
    link: 'Saada päring',
  },
  gallery: {
    title: 'Tall',
    intro:
      'Puidust tall 16 boksiga ja 16,5 hektarit oma maad — karjamaad, mets lähedal ja maaelu vaikus vaid 25 km kaugusel Tallinnast.',
    open: 'Ava foto',
    more: '+{n} fotot',
    close: 'Sulge',
    prev: 'Eelmine foto',
    next: 'Järgmine foto',
  },
  horses: {
    title: 'Meie hobused',
    intro:
      'Kõik meie kaheksa hobust on kestvussõiduks treenitud araabia hobused — vastupidavad, kindla sammuga ja sõbralikud. Räägi meile oma tasemest ja valime sulle sobiva hobuse.',
    calm: 'Rahulikud hobused',
    calmDesc: 'Algajatele ja kesktaseme ratsanikele. Samm ja kerge traav.',
    advanced: 'Hobused kogenud ratsanikele',
    advancedDesc: 'Kindlatele ratsanikele, kes traavivad ja galopeerivad iseseisvalt.',
    age: '{n}-aastane',
  },
  routes: { forest: 'Mets', sea: 'Meri' },
  rides: {
    title: 'Matkad ja hinnad',
    intro: 'Mets või meri. Päeva marsruudi valib juhendaja vastavalt ilmale ja pinnasele.',
    forest: 'Metsamatkad',
    forestDesc: 'Pehmed rajad mändide ja kaskede all, tuule eest varjus — meie valik külmadel ja tuulistel päevadel.',
    sea: 'Merematkad',
    seaDesc: 'Läbi luidete laiale liivarannale. Parim vaikse ilmaga; kogenud ratsanikud saavad galopeerida veepiiril.',
    colRide: 'Matk',
    colLevel: 'Tase',
    colDuration: 'Sadulas',
    colPrice: 'Hind',
    perRider: 'ratsaniku kohta',
    perGroup: 'kahele',
    min: 'min',
    book: 'Vali',
    prepNote:
      'Lisaks 30 minutit enne (hobuse puhastamine ja saduldamine koos sinuga) ja 30 minutit pärast (varustuse eemaldamine ja hoolitsus). Sisaldub hinnas.',
    includedTitle: 'Iga matk sisaldab',
    included: [
      'Tutvumist hobusega ja lühikest ohutusjuhendamist',
      'Hobuse puhastamist ja saduldamist koos juhendajaga',
      'Kiivrit',
      'Soovi korral lühikest fotosessiooni hobuse seljas',
      'Aega hobustega pärast matka — harjamine ja porgandid',
      'Teed ja kohvi talli puhkeruumis',
    ],
    winterTitle: 'Talvehind',
    winterText: 'Novembrist märtsini {amount} soodsam iga ratsaniku kohta igal matkal. Rakendub broneerimisel automaatselt.',
    stebbyTitle: 'Maksa sporditoetusega',
    stebbyText: 'Meie matku saab tasuda tööandja sporditoetusega Stebby keskkonnas.',
    extrasTitle: 'Veel pakume',
    gift: 'Kinkekaart',
    giftDesc: 'Ükskõik milline matk kingituseks, kehtib 12 kuud.',
    pack: '5 matka pakett',
    packDesc: '10% soodsam, saab jagada pereliikmetega.',
    private: 'Privaatmatk',
    privateDesc: 'Ainult sina ja juhendaja — +20 € matka kohta.',
  },
  booking: {
    title: 'Broneerimine',
    intro: 'Vali matk — broneerimiskalender avaneb otse siin lehel. Vali kuupäev ja kellaaeg, nõustu tingimustega ja maksa internetis.',
    steps: [
      { title: 'Vali matk', text: 'Iga nupp avab just selle matka kalendri.' },
      { title: 'Vali kuupäev ja kellaaeg', text: 'Näitame ainult valgeid aegu ja päevi, kus on vabu hobuseid. Esmaspäev on puhkepäev.' },
      { title: 'Kinnita ja maksa', text: 'Nõustu tingimustega ja maksa kaardi, Apple Pay või Google Payga. Kinnitus tuleb e-postile.' },
    ],
    chooseTitle: 'Vali matk',
    book: 'Broneeri',
    allTimes: 'Pole veel kindel? Kõik matkad ja ajad',
    assurances: [
      'Tasuta tühistamine kuni 24 tundi enne matka',
      'Halb ilm — tasuta ümberbroneerimine või raha tagasi',
      'Talvehind novembrist märtsini',
      'Maksad Stebbyga? Kirjuta meile ja saadame lingi.',
    ],
    agreeTitle: 'Enne broneerimist',
    agreeIntro: 'Palun kinnita iga broneeringus oleva ratsaniku eest:',
    requirements: 'Iga ratsanik on vähemalt 10-aastane ja kaalub alla 95 kg.',
    agreeLiability:
      'Mõistan, et ratsutamine on riskantne, ja ratsutan omal vastutusel. Tall ei vastuta vigastuste ega kahjude eest.',
    agreeInsurance: 'Igal minu broneeringus oleval ratsanikul on isiklik õnnetusjuhtumikindlustus.',
    agreeCancel: 'Tasuta tühistamine kuni 24 tundi enne matka. Hilisemal tühistamisel raha ei tagastata.',
    mustAgree: 'Jätkamiseks nõustu kõigi tingimustega.',
    continue: 'Edasi kuupäeva ja kellaaja valimisele',
    modalTitle: 'Broneerimine',
    loading: 'Laadime broneerimiskalendrit…',
    soonTitle: 'Online-broneerimine avaneb peagi',
    soonText: 'Seni broneeri telefoni või e-posti teel — vastame samal päeval.',
    call: 'Helista',
    write: 'Kirjuta e-kiri',
    close: 'Sulge',
  },
  events: {
    title: 'Pulmad, fotosessioonid ja peod',
    intro:
      'Aprillist oktoobrini on meie hobused, heinapallidega niidud ja mets teie taustaks. 2027. hooaja kuupäevi saab broneerida alates 1. novembrist — saada päring kohe, et olla järjekorras esimene.',
    from: 'alates',
    season: 'Hooaeg: aprill – oktoober',
    request: 'Kuupäeva päring',
    name: 'Nimi',
    email: 'E-post',
    date: 'Soovitud kuupäev',
    type: 'Sündmus',
    message: 'Räägi oma plaanidest',
    send: 'Saada päring',
    sent: 'Aitäh! Vastame kahe päeva jooksul.',
    required: 'Palun täida nimi, e-post ja kuupäev.',
  },
  rules: {
    title: 'Hea teada',
    intro: 'Loe enne broneerimist — makstes nõustud nende tingimustega.',
    items: [
      {
        title: 'Ilm',
        text: 'Me ei sõida alla −15 °C ega üle +28 °C, äikese ajal, tuulega üle 15 m/s ega jäisel pinnasel. Juhendaja kinnitab matka matkapäeval kella 9:00-ks. Kui tühistame meie, saad tasuta ümberbroneerimise või raha täielikult tagasi.',
      },
      {
        title: 'Valge aeg',
        text: 'Sõidame ainult valgel ajal. Detsembris umbes 10:00–15:00, suvel 9:00–21:00. Kalender näitab saadaolevaid aegu ise.',
      },
      {
        title: 'Tühistamine',
        text: 'Tasuta kuni 24 tundi enne algust. Hiljem raha ei tagastata, kuid koha võib anda üle teisele inimesele.',
      },
      {
        title: 'Hobuse ettevalmistus',
        text: 'Saabu 30 minutit varem: puhastame koos hobuse ja paneme varustuse selga. Pärast matka veel 30 minutit — varustuse eemaldamine ja hobuse eest hoolitsemine.',
      },
      {
        title: 'Vastutus ja kindlustus',
        text: 'Ratsutamine on kõrgendatud riskiga tegevus. Broneerides nõustud, et ratsutad omal vastutusel ja tall ei vastuta. Õnnetusjuhtumikindlustuse vormistab iga ratsanik ise.',
      },
      {
        title: 'Nõuded',
        text: 'Vanus alates 10 aastast (alla 16 vanema nõusolekul), kaal kuni 95 kg. Kiivri anname meie. Vajalikud on kinnised madala kontsaga jalanõud ja ilmale sobivad riided.',
      },
    ],
  },
  footer: {
    tagline: 'Ratsamatkad metsas ja mere ääres Eestis.',
    contact: 'Kontakt',
    rights: 'Kõik õigused kaitstud.',
  },
};
